export default __webpack_public_path__ + "static/media/OTEL_Lab-Validation-Services.0ddf2c9f.mp4";